<template>
  <div>
    <div>
      <div v-for="(subcategory, index) of subcategories"
           :key="index">
        <p class="title mt-4 mb-1">
          {{ formattingTitle (subcategory.title) }}
        </p>
        <div v-for="(item, index) of subcategory.items"
             :key="index">
          <p v-if="!index"
             :class="item && 'border border-dark py-3 pl-2 mb-0'">
            {{ item }}
          </p>
          <p v-else
             :class="item && 'border border-dark border-top-0 py-3 pl-2 mb-0'">
            {{ item }}
          </p>
        </div>
      </div>
    </div>

    <div class="buttonContainerBorder d-flex justify-content-end mt-5">
      <button class="button my-4"
              @click="goToLastUpdates">
        Voltar
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Subcategory',
    props: {
      propsData: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        subcategories: []
      }
    },
    watch: {
      propsData: {
        handler (newValue) {
          this.subcategories = newValue
        },
        deep: true
      }
    },
    destroyed () {
      this.subcategories = []
    },
    methods: {
      goToLastUpdates () {
        this.$router.push({ name: 'latest-release-updates'})
      },
      formattingTitle (title) {   
        return title && title.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
      }
    }
  }
</script>

<style lang="scss" scoped>
.title {
  color: #074F7F;
  font-weight: 500;
}
.buttonContainerBorder{
  border-top: 2px solid #074F7F;
}
.button {
  background-color: #C6C6C6;
  border: none;
  padding: 8px 30px;
  border-radius: 4px;
  
  &:hover {
    background-color: #b2b2b2;
    color:#ffffff;
  }
}
</style>
